import React from "react";
import { Star, Check, ArrowRight, Sparkles } from "lucide-react";
import { BRAND } from "../mock";

const Hero = () => {
  return (
    <section className="relative overflow-hidden coral-soft">
      <div className="max-w-7xl mx-auto px-4 pt-10 pb-16 md:pt-16 md:pb-24 grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="order-2 lg:order-1">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1A1410] text-[#FFF2EC] text-[11px] font-semibold tracking-[0.2em] uppercase">
            <Sparkles className="w-3 h-3 text-[#FFB89E]" />
            New Arrival
          </div>

          <h1 className="font-serif-display mt-5 text-[40px] leading-[1.02] sm:text-[54px] md:text-[68px] lg:text-[74px] font-semibold text-[#1A1410]">
            Elevate Your
            <br />
            Physique.
            <br />
            <span className="italic text-[#DD4D2A]">Feel The</span>{" "}
            <span className="italic">Difference.</span>
          </h1>

          <div className="mt-6 flex items-center gap-3">
            <div className="flex items-center">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-[18px] h-[18px] fill-[#DD4D2A] text-[#DD4D2A]"
                />
              ))}
            </div>
            <span className="text-sm font-medium text-[#1A1410]/75">
              4.8/5 based on 10,000+ reviews
            </span>
          </div>

          <ul className="mt-7 space-y-3 max-w-lg">
            {[
              "Burn calories without beating up your joints",
              "Supports lymphatic drainage for your ideal physique",
              "Perfect for busy schedules — just 15 minutes a day",
            ].map((t) => (
              <li key={t} className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-[#DD4D2A] text-white flex items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3" strokeWidth={3} />
                </span>
                <span className="text-[15px] md:text-base text-[#1A1410]/85">
                  {t}
                </span>
              </li>
            ))}
          </ul>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:items-center">
            <a
              href="#shop"
              className="btn-coral inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-sm uppercase"
            >
              Shop Now
              <ArrowRight className="w-4 h-4" />
            </a>
            <span className="text-sm text-[#1A1410]/70">
              60-Day Money-Back Guarantee
            </span>
          </div>
        </div>

        {/* Visual */}
        <div className="order-1 lg:order-2 relative">
          <div className="relative coral-radial rounded-[32px] overflow-hidden aspect-[4/5] lg:aspect-[5/6] noise">
            <img
              src="https://images.pexels.com/photos/6571945/pexels-photo-6571945.jpeg"
              alt="Woman exercising on rebounder"
              className="absolute inset-0 w-full h-full object-cover mix-blend-multiply"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#DD4D2A]/35 via-transparent to-transparent" />

            {/* Floating badge */}
            <div className="absolute top-5 left-5 bg-[#FFF2EC] rounded-2xl px-4 py-3 shadow-xl">
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#1A1410]/60">
                Trusted by
              </div>
              <div className="font-serif-display text-2xl font-semibold">
                500k+ women
              </div>
            </div>

            <div className="absolute bottom-5 right-5 bg-[#1A1410] text-[#FFF2EC] rounded-2xl px-5 py-4 shadow-xl max-w-[240px]">
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#FFB89E]">
                Limited Offer
              </div>
              <div className="font-serif-display text-xl font-semibold mt-0.5">
                Save up to $200
              </div>
              <div className="text-xs text-[#FFF2EC]/70 mt-1">
                on best-selling rebounders
              </div>
            </div>
          </div>

          {/* Tiny counter */}
          <div className="absolute -bottom-6 left-6 bg-[#FFF2EC] border border-[#1A1410]/10 rounded-full px-5 py-2 shadow-md flex items-center gap-3">
            <div className="flex -space-x-2">
              {[
                "https://images.unsplash.com/photo-1606902965551-dce093cda6e7",
                "https://images.unsplash.com/photo-1774414489812-f863c5bd32f4",
                "https://images.pexels.com/photos/5836973/pexels-photo-5836973.jpeg",
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  className="w-7 h-7 rounded-full border-2 border-[#FFF2EC] object-cover"
                />
              ))}
            </div>
            <span className="text-xs font-medium">
              10,000+ happy customers
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
